/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarList\CarList.type.ts
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, January 25th 2023, 10:17:11 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import Config from "Config/Config";

class CarCost {
  public carCost = 0;

  public fromJson(jsonObj: any) {
    this.carCost = parseInt(jsonObj.SellPrice);
  }
}

class IconSubSection {
  IconSubSection = "";

  public fromJson(jsonObj: any) {
    this.IconSubSection = jsonObj.SubSection;
  }
}

class CarInfo {
  public Brand = "";
  public Model = "";
  public Version = "";
  public Mileage = 0;
  public CirculationDate: Date = new Date();
  public Gears = "";
  public Energy = "";
  public Status = "";

  public fromJson(jsonObj: any) {
    this.Brand = jsonObj.Brand;
    this.Model = jsonObj.Model;
    this.Version = jsonObj.Version;
    this.Mileage = parseInt(jsonObj.Mileage);
    this.CirculationDate = new Date(jsonObj.CirculationDate);
    this.Gears = jsonObj.Gears;
    this.Energy = jsonObj.Energy;
    this.Status = jsonObj.Status;
  }
}

class CarImg {
  public url: string =
    Config.BACKEND.BASEURL + Config.BACKEND.PATHS.GET_PICTURE + `${1}`;
  public status = "";
  public subSection = "";

  public fromJson(jsonObj: any) {
    this.url =
      Config.BACKEND.BASEURL +
      Config.BACKEND.PATHS.GET_PICTURE +
      `${jsonObj.id}`;
    this.status = jsonObj.Status;
    this.subSection = jsonObj.SubSection;
  }
}

export class CarListable {
  public id = 0;
  public carCost: CarCost = new CarCost();
  public carInfo: CarInfo = new CarInfo();
  public iconSubSection: IconSubSection = new IconSubSection();
  public carImg: CarImg = new CarImg();

  public fromJson(jsonObj: any): void {
    this.id = jsonObj.id;
    this.carCost.fromJson(jsonObj);
    this.iconSubSection.fromJson(jsonObj);
    this.carInfo.fromJson(jsonObj);
    this.carImg.fromJson(jsonObj);
  }
}
